const DEFAULT_MAX_LINE_LENGTH = 20;

/**
 * @param {string} label
 * @param {number} [maxLineLength]
 * @returns {string[]}
 */
export function wrapCategoryLabelIntoLines(label, maxLineLength = DEFAULT_MAX_LINE_LENGTH) {
  const words = String(label ?? "")
    .trim()
    .split(/\s+/);
  if (words.length === 0 || (words.length === 1 && words[0] === "")) {
    return [""];
  }

  const lines = [];
  let currentLine = "";

  words.forEach((word) => {
    if (currentLine.length + word.length + 1 <= maxLineLength) {
      currentLine += (currentLine.length ? " " : "") + word;
    } else {
      if (currentLine.length) {
        lines.push(currentLine);
      }
      currentLine = word;
    }
  });

  if (currentLine.length) {
    lines.push(currentLine);
  }

  return lines.length > 0 ? lines : [""];
}

/**
 * @param {number} [maxLineLength]
 * @returns {(this: import('chart.js').Scale, value: string | number) => string | string[]}
 */
export function createChartJsCategoryAxisTickWordWrapCallback(
  maxLineLength = DEFAULT_MAX_LINE_LENGTH
) {
  return function wrapCategoryTickLabel(value) {
    const label = this.getLabelForValue(value);
    return wrapCategoryLabelIntoLines(label, maxLineLength);
  };
}

/**
 * Chart.js `scales.x.ticks` config for visible, word-wrapped category labels.
 * @param {number} [maxLineLength]
 */
export function chartJsCategoryAxisTicksWithWordWrap(maxLineLength = DEFAULT_MAX_LINE_LENGTH) {
  return {
    callback: createChartJsCategoryAxisTickWordWrapCallback(maxLineLength),
    maxRotation: 0,
    autoSkip: false,
  };
}
